import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const treasureIslandConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Treasure Island Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Treasure Island, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_treasure_island',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Treasure Island',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Treasure Island Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the residential and vacation 
     properties of <strong>Treasure Island</strong> with professional tree care built 
     for barrier island conditions. The combination of Gulf exposure, Intracoastal 
     waterway winds, and Florida's hurricane season puts enormous pressure on trees here 
     and when those trees become hazards to your home or rental property, our team 
     steps in fast with the skill and equipment to handle it safely.`,

    `We specialize in <strong>dangerous and storm damaged tree situations</strong> 
     palms and hardwoods weakened by salt and wind, overhanging limbs near rooftops 
     and pool decks, trees leaning toward seawalls or neighboring properties, and 
     post storm cleanup that restores your property quickly. We work on tight island 
     lots every day.`,

    `<strong>Sam's Tree Service</strong> delivers reliable tree care throughout 
     <strong>Treasure Island</strong> and the <strong>South Pinellas Gulf beaches</strong> 
     corridor keeping your island property safe, clean, and protected through 
     every storm season.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Treasure Island, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_TreasureIsland = () => <LocationPage config={treasureIslandConfig} />;
export default Services_TreasureIsland;
